import styled from 'styled-components'

export const Image = styled.img`
  width: 40px;
  height: 40px;
`
